// extracted by mini-css-extract-plugin
module.exports = {"pintxo-field-container":"Field_pintxo-field-container__W4SKD","pintxo-field-container__footer":"Field_pintxo-field-container__footer__FW6_E"};